import config from './config';
import EventBus from '../eventBus';
import {
	mapGetters
} from 'vuex'
import {
	mapActions
} from 'vuex'

export const func = {
	data() {
		return {
			typingTimer: null,
			savingAnimationTimer: null,
			doneTypingInterval: 2000,
			milestoneList: [],
			proposalData: {}
		}
	},
	computed: {
		...mapGetters(['milestones', 'proposal'])
	},
	methods: {
		keyPressManager(event) {
			let keyPressed = event.key;
			let shiftKeyPressed = event.shiftKey;

			switch (keyPressed) {
				case 'Enter':
					event.preventDefault();
					if (shiftKeyPressed) {
						this.addPhase();
					} else if (event.altKey) {
						let input = event.target;
						input.value += '\n';
						this.autosize(input);
					} else {
						this.addSibling();
					}

					break;
				case 'ArrowLeft':
					shiftKeyPressed && this.shiftOut();
					break;
				case 'ArrowRight':
					shiftKeyPressed && this.shiftIn();
					break;
				case 'ArrowDown':
					shiftKeyPressed && this.switchWithLowerSibling();
					break;
				case 'ArrowUp':
					shiftKeyPressed && this.switchWithUpperSibling();
					break;
			}
		},
		keyPressManagerChildren(event) {
			let keyPressed = event.key;
			let shiftKeyPressed = event.shiftKey;
			switch (keyPressed) {
				case 'Enter':
					event.preventDefault();
					if (event.altKey) {
                        let input = event.target;
						input.value += '\n';
						this.autosize(input);
					} else {
						this.addSiblingChildren();
					}
					break;
				case 'ArrowLeft':
					shiftKeyPressed && this.shiftOut();
					break;
				case 'ArrowRight':
					shiftKeyPressed && this.shiftIn();
					break;
				case 'ArrowDown':
					shiftKeyPressed && this.switchWithLowerSibling();
					break;
				case 'ArrowUp':
					shiftKeyPressed && this.switchWithUpperSibling();
					break;
			}
		},

		addSiblingChildren() {
			this.$store.dispatch('addSibling', {
				id: 0,
				values: {
					name: "",
					time: "",
					price: "",
					toggleButtonIsChecked: false,
					parentID: this.id,
				},
				children: [],
			});
		},
		addPhase() {
			this.$store.dispatch('addPhase', {
				id: 0,
				values: {
					name: "Phase ",
					time: "",
					price: "",
					info: "",
					parentID: 0,
					"Price-Long": "",
					"Time-Long": "",
					"Taxes-19": true,
					"Taxes-19-Long": "",
					"Taxes-7-Long": "",
					"Taxes-5-Long": "",
					"Taxes-16-Long": "",
				},
				children: [],
			});
			this.saveMilestones();
		},
		addChild() {
			this.$store.dispatch('addChild', {
				id: 0,
				values: {
					name: "",
					time: "",
					price: "",
					pageBreak: false,
					bulletPoint: true,
					parentID: this.id
				},
				children: []
			});
			this.saveMilestones();
		},
		addSibling() {
			this.$store.dispatch('addSibling', {
				id: 0,
				values: {
					name: "",
					time: "",
					price: "",
					info: "",
					pageBreak: false,
					bulletPoint: true,
					parentID: this.id,
					"Price-Long": "",
					"Time-Long": "",
					"Taxes-19": true,
					"Taxes-19-Long": "",
					"Taxes-7-Long": "",
					"Taxes-5-Long": "",
					"Taxes-16-Long": "",
				},
				children: []
			});
			this.saveMilestones();

			const newMilestone = this.milestones.items[this.milestones.items.length - 1];
			EventBus.$emit('open-phase-info', newMilestone.id, this.proposal.id, '');
		},
		removeTile() {
			EventBus.$emit('close-phase-info', this.id, this.proposal.id, '');

			let self = $(this.$el);
			let children = self.find("li").length;

			let milestones = this.milestones.items;
			if (children > 20) {
				EventBus.$emit('openModal', this.id);
			} else {
				this.$store.dispatch('removeTile', this.id);
				this.saveMilestones();
			}
		},
		switchWithLowerSibling() {
			this.$store.dispatch('switchWithLowerSibling', this.id);
			this.saveMilestones();

		},
		switchWithUpperSibling() {
			this.$store.dispatch('switchWithUpperSibling', this.id);
			this.saveMilestones();

		},
		shiftOut() {
			this.$store.dispatch('shiftOut', this.id);
			this.saveMilestones();

		},
		shiftIn() {
			this.$store.dispatch('shiftIn', this.id);
			this.saveMilestones();

		},
		updateTime() {
			this.$store.dispatch('updateTime');
			this.saveMilestones();
		},
		updatePrice() {
			this.$store.dispatch('updatePrice');
			this.saveMilestones();
		},
		replaceAll(str, find, replace) {
			return str.replace(new RegExp(find, 'g'), replace);
		},
		hasClass(target, className) {
			return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
		},
		getDate() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1;
			var yyyy = today.getFullYear();

			if (dd < 10) {
				dd = '0' + dd
			}

			if (mm < 10) {
				mm = '0' + mm
			}

			today = dd + '.' + mm + '.' + yyyy;
			return today;
		},
		isPercentageBased(value) {
			return (value[value.length - 1] === '%');
		},
		save() {
			let proposalData = {};

			proposalData.projectInfo = this.projectInfo;
			proposalData.confirmation = this.confirmation;
			proposalData.milestones = this.milestones;

			localStorage.setItem('PROPOSAL_DATA', JSON.stringify(proposalData));

			this.saveMilestones();
			this.startSavingAnimation();

			clearTimeout(this.typingTimer);
			this.typingTimer = setTimeout(this.stopSavingAnimation, this.doneTypingInterval);
		},
		saveMilestones() {
			let data = {};
			data.milestones = this.milestones;
			data.id = this.proposal.id;
			this.$store.dispatch('updateMilestones', data);
		},
		stopSavingAnimation() {
			setTimeout(() => {
				EventBus.$emit('stopSaving');
			}, 3800);
		},
		startSavingAnimation() {
			EventBus.$emit('startSaving');
		},
		autosize(el) {
			el.style.height = 'auto';
			el.style.height = el.scrollHeight + 'px';
		},
	}
}



// WEBPACK FOOTER //
// ./src/mixins/functions.js